import { Alert, Button } from "@mui/material";
import ManageSearchOutlinedIcon from "@mui/icons-material/ManageSearchOutlined";
import { useReadOnlyUser } from "@/hooks/useReadOnlyUser";
import { UserConfigGetAPI } from "@/features/accountSettings/api/UserConfigAPI";
import { useAiStoredPicturesDownload } from "../hooks/useAiStoredPicturesDownload";
import { type AiStoredPictureSearch } from "../types";
import { AiStoredPicturesDownloadDialog } from "./AiStoredPicturesDownloadDialog";
import { AiStoredPicturesResultsDialog } from "./AiStoredPicturesResultsDialog";

interface AiStoredPicturesDownloadFlowProps {
  search: AiStoredPictureSearch;
}

export const AiStoredPicturesDownloadFlow: React.FC<
  AiStoredPicturesDownloadFlowProps
> = ({ search }) => {
  const isReadOnly = useReadOnlyUser();
  const userConfig = UserConfigGetAPI();
  const download = useAiStoredPicturesDownload(search.results);

  return (
    <>
      <Button
        variant="contained"
        size="small"
        startIcon={<ManageSearchOutlinedIcon />}
        onClick={download.openResults}
        sx={{ mt: 1.5 }}
      >
        検索結果を表示（{search.returnedCount}件）
      </Button>

      {download.preparationError !== "" && (
        <Alert severity="error" sx={{ mt: 1.5 }}>
          {download.preparationError}
        </Alert>
      )}

      <AiStoredPicturesResultsDialog
        open={download.isResultsOpen}
        search={search}
        selectedIds={download.selectedIds}
        isReadOnly={isReadOnly}
        onSelectedIdsChange={download.setSelectedIds}
        onClose={download.closeResults}
        onContinue={download.openDownloadConfirmation}
      />

      {download.downloadPreparation !== null && (
        <AiStoredPicturesDownloadDialog
          open={download.isDownloadOpen}
          preparation={download.downloadPreparation}
          query={search.query}
          isPriceHidden={userConfig?.isPriceHidden ?? true}
          isReadOnly={isReadOnly}
          isSubmitting={download.isDownloading}
          errorMessage={download.downloadError}
          onClose={download.closeDownload}
          onSubmit={() => {
            void download.downloadSelectedResults();
          }}
        />
      )}
    </>
  );
};
